//* 组件库
import { $loading, type UiModal } from "various-ui";
//* 私有组件
import type ModalAdd from "../components/add/index.vue";
import type ModalMessage from "../components/message/index.vue";
//* 组件属性
import type { ModuleData } from "../index";

export const useComposable = () => {
    //* 插件
    const i18n = useI18n();

    //* 响应式变量
    const refs = {
        data: ref<ModuleData[]>([]),
    };

    //* 节点
    const nodes = {
        info: ref<InstanceType<typeof UiModal>>(),
        modal: ref<InstanceType<typeof ModalAdd>>(),
        message: ref<InstanceType<typeof ModalMessage>>(),
    };

    //* 函数列表
    const methods = {
        //* 跳转函数
        image: () => open(routerResolve({ name: "SequenceAlignmentTutorials" }).href, "_blank"),
        next: () => {
            if (i18n.locale.value == "zh") open("https://www.bilibili.com/video/BV1yVGXzqEQ5", "_blank");
            else {
                open("https://www.youtube.com/watch?v=Qmg87dUZ7ig", "_blank");
            }
        },

        //* 打开添加序列弹窗
        open: () => {
            //* 超20条提示
            if (refs.data.value.length == 20) nodes.message.value?.open(i18n.t("SequenceAlignmentNotification2"));
            else {
                nodes.modal.value?.open();
            }
        },

        //* 删除
        remove: (index: number) => refs.data.value.splice(index, 1),
        //* 新增
        change: (datas: ModuleData[], success: () => void, key?: number) => {
            //* 数据更新
            if (key != undefined && key >= 0) refs.data.value.splice(key, 1, ...datas);
            else {
                refs.data.value.push(...datas);
            }

            //* 数据删减
            refs.data.value.splice(20);
            //* 触发添加成功回调
            success();
        },

        //* 提交
        submit: () => {
            if (refs.data.value.length < 2) nodes.message.value?.open(i18n.t("SequenceAlignmentNotification1"));
            else {
                //* 判断序列是否符合规则
                let temp = true;
                const protein = Object.keys(Contrast.Protein).join("").replace(/\*/g, "");
                refs.data.value.forEach((value) => {
                    if (!(/^[ATCG]+$/.test(value.sequence) || new RegExp(`^[${protein}]+(\\*)?$`).test(value.sequence))) {
                        nodes.message.value?.open(i18n.t("SequencesFormat"));
                        temp = false;
                    }
                });
                if (!temp) return false;

                //* 数据初始化
                const data = refs.data.value.map((value) => {
                    const result = { seq: value.sequence, name: value.name };
                    if (value.mode == "Custom") return result;
                    else {
                        const sequence = value.sequences.find((v) => v.value == value.tran_pro_id);
                        if (!sequence) return result;
                        else {
                            return Object.assign(result, { gene_id: value.id, seq_type: sequence.type, tran_pro_id: sequence.id });
                        }
                    }
                });
                //* 提交任务
                $loading.open({ message: i18n.t("UnderLoad") });
                api.frontend(`/api/bio/sequence-alignment`, {
                    data: { data: data },
                    method: "POST",
                    finally: () => $loading.close(),
                    success: (response) => {
                        open(routerResolve({ name: "SequenceAlignmentResult", query: { uuid: response } }).href, "_blank");
                    },
                });
            }
        },
    };

    return { refs, nodes, methods };
};
